import * as React from "react";

import { Label } from "@/DesignSystem/shadcn/Label/Label";
import { Checkbox } from "@/components/common/Checkbox/Checkbox";
import { cn } from "@/lib/utils";

export const SimpleCheckbox = ({
  checkboxClassName,
  labelClassName,
  containerClassName,
  label,
  name,
  value,
  disabled,
  onChange,
}: {
  checkboxClassName?: string;
  labelClassName?: string;
  containerClassName?: string;
  label: string;
  name?: string;
  value: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
}) => {
  const id = React.useId();

  // Use auto-generated ID if none is provided
  if (!name) {
    name = id;
  }

  return (
    <div className={containerClassName}>
      <Checkbox
        disabled={disabled}
        className={checkboxClassName}
        id={name}
        checked={value}
        onCheckedChange={(checked) => {
          onChange(checked === "indeterminate" ? false : Boolean(checked));
        }}
      />

      <Label data-testid={"label_" + name} htmlFor={name} className={cn("ml-2", labelClassName)}>
        {label}
      </Label>
    </div>
  );
};
